import React from 'react';
import { ISVGType } from './SVGType';

const ViewAllSVG = (props: ISVGType) => {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="34" viewBox="0 0 33 34" fill="none">
      <mask id="mask0_1025_235" style={{'maskType':'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="33" height="34">
        <rect x="12.1077" y="33.3923" width="24" height="24" transform="rotate(-120 12.1077 33.3923)" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_1025_235)">
        <path d="M21.6961 14L19.5 22.1961L17.5875 21.6837L18.9052 16.766L10.9378 21.366L9.9378 19.6339L17.9052 15.0339L12.9875 13.7162L13.5 11.8038L21.6961 14Z" fill="white"/>
      </g>
    </svg>
  );
};

export default ViewAllSVG;
